export const initialState = {
  mfaSettings: []
};
